import { render } from "./PosVe.vue?vue&type=template&id=5c3944ed&scoped=true"
import script from "./PosVe.vue?vue&type=script&lang=js"
export * from "./PosVe.vue?vue&type=script&lang=js"

import "./PosVe.vue?vue&type=style&index=0&id=5c3944ed&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/BEELIA/mi-stock-beelia-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3944ed"]])

export default __exports__